module.exports = __webpack_public_path__ + "assets/astraleah.509a2da4.png";